import Api from './Api';
import Configuracao from '../util/Configuracao';

class ElementoApi extends Api {
  async consultarElementosDaGuia (codLoteGuia, codGuia) {
    try {
      var result = [];
      const urlConsultarProcedimentos = Configuracao.getConfiguracao().urlConsultarElementos + codLoteGuia + '/guia/' + codGuia + '/procedimento';
      const responseProcedimento = await this.fetch(urlConsultarProcedimentos);
      const urlConsultarOutrasDespesas = Configuracao.getConfiguracao().urlConsultarElementos + codLoteGuia + '/guia/' + codGuia + '/outradespesa';
      const responseOutrasDespesas = await this.fetch(urlConsultarOutrasDespesas);
      const urlConsultarOpmes = Configuracao.getConfiguracao().urlConsultarElementos + codLoteGuia + '/guia/' + codGuia + '/opme';
      const responseOpme = await this.fetch(urlConsultarOpmes);
      result = responseProcedimento.data.concat(responseOutrasDespesas.data.concat(responseOpme.data));
      return result;
    } catch (error) {
      console.error(error);
    }
  }
  async salvarAuditoriaElemento (codLoteGuia, elemento) {
    const urlSalvarAuditoriaElemento = Configuracao.getConfiguracao().urlSalvarAuditoriaElemento + '/' + codLoteGuia;
    try {
      const result = this.fetch(urlSalvarAuditoriaElemento, 'POST', elemento, { 'content-type': 'application/json' });
      return result;
    } catch (error) {
      return error;
    }
  }
  async aceitarAuditoriaElementoCNU (codLoteGuia, elemento) {
    const urlAceitarAuditoriaElementoCNU = Configuracao.getConfiguracao().urlAceitarAuditoriaElementoCNU + codLoteGuia;
    try {
      const result = this.fetch(urlAceitarAuditoriaElementoCNU, 'POST', elemento, { 'content-type': 'application/json' });
      return result;
    } catch (error) {
      return error;
    }
  }
  async excluirElementoCNU (codLoteGuia, elemento) {
    const urlExcluirElementoCNU = Configuracao.getConfiguracao().urlExcluirElementoCNU + codLoteGuia;
    try {
      const result = this.fetch(urlExcluirElementoCNU, 'POST', elemento, { 'content-type': 'application/json' });
      return result;
    } catch (error) {
      return error;
    }
  }
  async rejeitarGlosaTST (codLoteGuia, elemento, txtJustificativa) {
    const urlRejeitarGlosaTST = Configuracao.getConfiguracao().urlRejeitarGlosaTST + codLoteGuia + '/' + txtJustificativa;
    try {
      const result = this.fetch(urlRejeitarGlosaTST, 'POST', elemento, { 'content-type': 'application/json' });
      return result;
    } catch (error) {
      return error;
    }
  }
  async desfazerAvaliacaoElementoCNU (codLoteGuia, elemento) {
    const urlDesfazerAvaliacaoElementoCNU = Configuracao.getConfiguracao().urlDesfazerAvaliacaoElementoCNU + codLoteGuia;
    try {
      const result = this.fetch(urlDesfazerAvaliacaoElementoCNU, 'POST', elemento, { 'content-type': 'application/json' });
      return result;
    } catch (error) {
      return error;
    }
  }
  async aceitarAditoriaElementosNaoAvaliados (codLoteGuia, codGuia) {
    const urlAceitarAditoriaElementosNaoAvaliados = Configuracao.getConfiguracao().urlAceitarAditoriaElementosNaoAvaliados + codLoteGuia + '/' + codGuia;
    try {
      const result = this.fetch(urlAceitarAditoriaElementosNaoAvaliados, 'POST');
      return result;
    } catch (error) {
      return error;
    }
  }
  async excluirElementosNaoAvaliados (codLoteGuia, codGuia) {
    const urlExcluirElementosNaoAvaliados = Configuracao.getConfiguracao().urlExcluirElementosNaoAvaliados + codLoteGuia + '/' + codGuia;
    try {
      const result = this.fetch(urlExcluirElementosNaoAvaliados, 'POST');
      return result;
    } catch (error) {
      return error;
    }
  }
  async desfazerAvaliacaoElementos (codLoteGuia, codGuia) {
    const urlDesfazerAvaliacaoElementos = Configuracao.getConfiguracao().urlDesfazerAvaliacaoElementos + codLoteGuia + '/' + codGuia;
    try {
      const result = this.fetch(urlDesfazerAvaliacaoElementos, 'POST');
      return result;
    } catch (error) {
      return error;
    }
  }
  async ajustarGlosasElementosDaGuiaCnu (codLoteGuia, codGuia) {
    const urlAjustarGlosasElementosDaGuiaCnu = Configuracao.getConfiguracao().urlAjustarGlosasElementosDaGuiaCnu + codLoteGuia + '/' + codGuia;
    try {
      const result = this.fetch(urlAjustarGlosasElementosDaGuiaCnu, 'POST');
      return result;
    } catch (error) {
      return error;
    }
  }
  async anexarArquivo (idElemento, nomeArquivo, txtObjetoGed, codTipoItem) {
    try {
      const urlAnexarArquivoCnu = Configuracao.getConfiguracao().urlAnexarArquivoCnu + idElemento + '/' + nomeArquivo + '/' + txtObjetoGed + '/' + codTipoItem;
      const response = await this.fetch(urlAnexarArquivoCnu, 'put');
      return response;
    } catch (error) {
      console.error(error);
    }
  }
  async consultarArquivos (idElemento, codTipoItem) {
    try {
      const consultarArquivosUrlCnu = Configuracao.getConfiguracao().consultarArquivosUrlCnu + idElemento + '/' + codTipoItem;
      const response = await this.fetch(consultarArquivosUrlCnu);
      return response.data;
    } catch (error) {
      console.error(error);
    }
  }
  async deletarArquivo (codArquivo) {
    try {
      const urlDeletarArquivoCnu = Configuracao.getConfiguracao().urlDeletarArquivoCnu + codArquivo;
      const response = await this.fetch(urlDeletarArquivoCnu, 'put');
      return response;
    } catch (error) {
      console.error(error);
    }
  }
}

export default ElementoApi;
